// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  SERVER_URL: 'http://localhost:8088/',
  //SERVER_URL: 'http://localhost:8080/cams/',
  //SERVER_URL : 'https://d1slzpcez6ahtn.cloudfront.net/cams/',
  //SERVER_URL: 'http://172.29.58.58:8080/cams/',
  //Default No of Record selection in datatable
  DEFAULT_PAGE_OPTIONS: [10, 15, 20],
  //Max. Records in Grid Per Page
  DEFAULT_PAGE_SIZE: 10,
  //Console will be off for the production, false in case using for dev and test
  production: true,
  //using HashLocationStrategy
  useHash: true,
  //Hot Module Replacement (HMR) is a key webpack feature that is not enable by default in Angular.
  //It allows for modules to be replaced without need for a full browser refresh.
  hmr: false,
  appVersion: require('../../package.json').version + '-dev',
  //Max. characters to be displayed in drag n drop
  MAX_CHARACTER_TO_DISPLAY_IN_DRAG_N_DROP: 500,
  //Max. characters to be displayed in tiles
  MAX_CHARACTER_TO_DISPLAY_IN_TILES: 100,
  //Max. no of audits to be dsiplayed in excel download in auditor n auditee bench
  MAX_AUDIT_COUNT_ALLOWED_FOR_EXCEL_DOWNLOAD: 20,
  //Max. file size to be uploaded in application
  MAX_UPLOAD_SIZE_IN_MB: 30,
  //Max. records to be downloaded in excel for All Observations in auditor n auditee bench
  AUDIT_BENCH_EXCEL_MAX_RECORD_LIMIT: 10000,
  //Restricited File extension during upload
  FILE_EXTN_NOT_ALLOWED_TO_UPLOAD: 'EXE,JAR,MDF',
  //TinyMCE configuration for all editor
  TINYMCE_CONFIG: {
    init: {
      default_link_target: '_blank',
      //height: 350,
      branding: false,
      table_responsive_width: true,
      image_advtab: true,
      //autoresize_bottom_margin: 20,
      menubar: 'edit format table',
      toolbar:
        'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | forecolor | backcolor |nanospell',
      statusbar: false,
      browser_spellcheck: true,
      nanospell_autostart: true,
      nanospell_dictionary: 'en',
      nanospell_ignore_words_with_numerals: true,
      nanospell_ignore_block_caps: false,
      nanospell_compact_menu: false,
      content_style:
        '.mce-content-body{font-color:#898a8b;font-family:Calibri,Verdana,Arial,Helvetica,sans-serif;} p{margin-top: 0px;margin-bottom: 0px;}',
      theam: 'advance',
      plugins: [
        'advlist autolink lists',
        'searchreplace',
        'insertdatetime table ',
        'paste',
        'textcolor',
        'colorpicker',
        'textcolor',
        'table',
        'autoresize',
      ],
      oninit: 'setPlainText',
      menu: {
        edit: { title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall' },
        format: {
          title: 'Format',
          items:
            'bold italic underline strikethrough superscript subscript | formats | removeformat',
        },
        table: { title: 'Table', items: 'inserttable tableprops deletetable | cell row column' },
        tools: { title: 'Tools', items: 'spellchecker code' },
      },
      force_br_newlines: true,
      force_p_newlines: false,
      paste_data_images: true,
      /* content_css : 'content.css,mycontent2.css' , */
      //toolbar: 'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | forecolor | backcolor |nanospell',
      fontsize_formats: '0.75rem !important ',
      autosave_ask_before_unload: true,
    },
  },
  //TinyMCE configuration for major escalation (foreground n background color are removed)
  TINYMCE_CONFIG_FOR_MAJOR_ESC: {
    init: {
      default_link_target: '_blank',
      //height: 350,
      external_plugins: { nanospell: '/nanospell/plugin.js' },
      branding: false,
      table_responsive_width: true,
      image_advtab: true,
      //autoresize_bottom_margin: 20,
      menubar: 'edit format table',
      toolbar:
        'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | nanospell',
      statusbar: false,
      browser_spellcheck: true,
      nanospell_server: 'java',
      nanospell_autostart: true,
      nanospell_dictionary: 'en',
      nanospell_ignore_words_with_numerals: true,
      nanospell_ignore_block_caps: false,
      nanospell_compact_menu: false,
      content_style:
        '.mce-content-body{font-color:#898a8b;font-family:Calibri,Verdana,Arial,Helvetica,sans-serif;} p{margin-top: 0px;margin-bottom: 0px;}',
      theam: 'advance',
      plugins: [
        'advlist autolink lists',
        'searchreplace',
        'insertdatetime table ',
        'paste',
        'textcolor',
        'colorpicker',
        'textcolor',
        'table',
        'autoresize',
      ],
      oninit: 'setPlainText',
      menu: {
        edit: { title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall' },
        format: {
          title: 'Format',
          items:
            'bold italic underline strikethrough superscript subscript | formats | removeformat',
        },
        table: { title: 'Table', items: 'inserttable tableprops deletetable | cell row column' },
        tools: { title: 'Tools', items: 'spellchecker code' },
      },
      force_br_newlines: true,
      force_p_newlines: false,
      paste_data_images: true,
      /* content_css : 'content.css,mycontent2.css' , */
      //toolbar: 'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | forecolor | backcolor |nanospell',
      fontsize_formats: '0.75rem !important ',
      autosave_ask_before_unload: true,
    },
  },
  TINYMCE_CONFIG_WITHOUT_FORMATTER: {
    init: {
      default_link_target: '_blank',
      //height: 350,
      //external_plugins: { nanospell: '/nanospell/plugin.js' },
      branding: false,
      table_responsive_width: true,
      image_advtab: true,
      //autoresize_bottom_margin: 20,
      menubar: false,
      // toolbar:
      //   'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist',
      toolbar: false,
      statusbar: false,
      browser_spellcheck: true,
      nanospell_server: 'java',
      nanospell_autostart: true,
      nanospell_dictionary: 'en',
      nanospell_ignore_words_with_numerals: true,
      nanospell_ignore_block_caps: false,
      nanospell_compact_menu: false,
      content_style:
        '.mce-content-body{font-color:#898a8b;font-family:Calibri,Verdana,Arial,Helvetica,sans-serif;} p{margin-top: 0px;margin-bottom: 0px;}',
      theam: 'advance',
      plugins: [
        'advlist autolink lists',
        'searchreplace',
        'insertdatetime table ',
        'paste',
        'textcolor',
        'colorpicker',
        'textcolor',
        'table',
        'autoresize',
      ],
      oninit: 'setPlainText',
      menu: {
        edit: { title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall' },
        format: {
          title: 'Format',
          items:
            'bold italic underline strikethrough superscript subscript | formats | removeformat',
        },
        table: { title: 'Table', items: 'inserttable tableprops deletetable | cell row column' },
        tools: { title: 'Tools', items: 'spellchecker code' },
      },
      force_br_newlines: true,
      force_p_newlines: false,
      paste_data_images: true,
      /* content_css : 'content.css,mycontent2.css' , */
      //toolbar: 'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | forecolor | backcolor |nanospell',
      fontsize_formats: '0.75rem !important ',
      autosave_ask_before_unload: true,
    },
  },
  TINYMCE_API_KEY: 'adq5zb47c6waziub4w06u054p5ml59p8s8tl51m8oayd9gpy',
  //Global helpdesk email used in incorrect sso credentials HTML page
  CAMS_SUPPORT_EMAILID: 'Support@mind-infotech.com',
};
